export default __webpack_public_path__ + "static/media/pdqn.75894386.png";